export const calculateCreatorEarning = (val: any) => {
  const creatorEarning = (val / 10000) * 100;
  return creatorEarning;
};
